import React from 'react';
import { OctagonX, TriangleAlert } from 'lucide-react';
import Tooltip from '../utils/Tooltip';
import './BuildValidityIndicator.css';

const ICONS = { error: OctagonX, warning: TriangleAlert };

/**
 * Status icon for an invalid initial build, shown at the end of the
 * class/level row. `error` (stop icon) means generation is blocked; `warning`
 * (triangle) means the solver can still recover by refilling unlocked slots.
 *
 * Takes the object returned by `describeInitialBuildValidity` — null when the
 * build is valid, in which case nothing renders.
 */
const BuildValidityIndicator = ({ status, className = '' }) => {
    if (!status) return null;

    const { severity, title, detail, hint } = status;
    const Icon = ICONS[severity] || TriangleAlert;
    const ariaLabel = [title && `${title}.`, detail, hint].filter(Boolean).join(' ');

    return (
        <Tooltip
            wrapperClassName={`build-validity ${className}`.trim()}
            content={(
                <div className="build-validity-tip">
                    {title ? <span className={`build-validity-tip-title ${severity}`}>{title}</span> : null}
                    <span className="build-validity-tip-detail">{detail}</span>
                    {hint ? <span className="build-validity-tip-hint">{hint}</span> : null}
                </div>
            )}
        >
            <span
                className={`build-validity-icon ${severity}`}
                role="status"
                aria-label={ariaLabel}
            >
                <Icon aria-hidden="true" />
            </span>
        </Tooltip>
    );
};

export default BuildValidityIndicator;
